import type { DiscoveryPlaylistElements } from "@redux/discoveryPlaylist/types";

import type { LocalesType } from "constants/locales";
import client from "services/networking/client";
import type { Genre } from "shared-types/genre";
import type {
	Playlist,
	ExtendedPlaylist,
	PlaylistInfo,
	NewPlaylist,
} from "shared-types/playlist";

import type { UserContext } from "shared-types/user";
import type { Playlist as PlaylistWithSongs } from "src/@types/api-types";

export const getPlaylists = async (
	userContext: UserContext,
	tagName?: string | null,
): Promise<Playlist[]> => {
	return client.get(
		`/playlists/bam?userContext=${userContext}${tagName ? `&tagName=${tagName}` : ""}`,
	);
};

export const getBamGenres = async (): Promise<Genre[]> => {
	return client.get("/genre");
};

export const getTagsAndPlaylists = async (
	language: LocalesType,
): Promise<DiscoveryPlaylistElements[]> => {
	return client.get(`/tags/playlists?language=${language.toLocaleUpperCase()}`);
};

export const getPlaylist = async (
	id: string,
	userContext: UserContext,
): Promise<ExtendedPlaylist> => {
	return client.get(`/playlists/bam/${id}?userContext=${userContext}`);
};

export const getGenreById = async (id: string): Promise<ExtendedPlaylist> => {
	return client.get(`/genre/${id}`);
};

export const getMyPlaylists = async (): Promise<PlaylistInfo[]> => {
	return client.get("/playlists/my-playlists");
};

export const getMyPlaylist = async (id: string): Promise<ExtendedPlaylist> => {
	return client.get(`/playlists/my-playlists/${id}`);
};

export const postPlaylist = async (
	playlist: NewPlaylist,
): Promise<ExtendedPlaylist> => {
	return client.post("/playlists", playlist);
};

export const deletePlaylist = async (id: string): Promise<void> => {
	return client.delete(`/playlists/${id}`);
};

export const addSongToPlaylist = async (
	playlistId: string,
	songId: string,
): Promise<ExtendedPlaylist> => {
	return client.patch(`/playlists/${playlistId}/add-song`, { songId });
};

export const modifyPlaylist = async (
	playlistId: string,
	newPlaylistName: string,
): Promise<ExtendedPlaylist> => {
	return client.patch(`/playlists/${playlistId}`, { newPlaylistName });
};

export const orderPlaylist = async (
	playlistId: string,
	songList: string[],
): Promise<ExtendedPlaylist> => {
	return client.patch(`/playlists/${playlistId}/reorder`, { songList });
};

export const gameRouletPlaylists = async (
	countryCode: string,
	userContext: UserContext,
	customerId: string | null,
): Promise<PlaylistWithSongs[]> => {
	return client.get(
		`/playlists/game/roullette?country=${countryCode}${`&userContext=${userContext}`}${customerId ? `&customerId=${customerId}` : ""}`,
	);
};

export const addToPlaylist = async (songId: string, playlistId: string): Promise<Playlist> => {
	return client.patch(`/playlists/${playlistId}/add-song`, {
		songId,
	})
}

export const removeFromPlaylist = async (songId: string, playlistId: string): Promise<Playlist> => {
	return client.delete(`/playlists/${playlistId}/remove-song`, {
		songId,
	})
}

export const getCustomerPlaylists = async (customerId: string): Promise<Playlist[]> => {
	return client.get(`/playlists/customer?customerId=${customerId}`)
}